<template>
    <div style='height: 98%'>
        <div class='crumbs mcrumb-self'>
            <el-breadcrumb separator='-'>
                <el-breadcrumb-item>
                    <i class='el-icon-setting'></i><span>系统设置</span>
                </el-breadcrumb-item>
                <el-breadcrumb-item><span>定时任务实例管理</span></el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class='container' style='padding: 15px; height: 92%'>
            <div style='padding-bottom: 10px'>
                <el-row type='flex'>
                    <el-col :span='8'>
                        <el-button type='primary' style='width: 80px' @click='scheduleInstanceClickFun(`0`, ``)'>新增
                        </el-button>
                    </el-col>
                </el-row>
            </div>
            <div style='height: 94%'>
                <el-table :data='scheduleTaskInstanceTableData' border stripe height='90%' class='table'
                          ref='scheduleTaskInstanceTable' highlight-current-row @row-click='clickRowByChecked'>
                    <el-table-column type='selection' width='55' align='center'></el-table-column>
                    <el-table-column prop='id' v-if='showColumn'></el-table-column>
                    <el-table-column prop='implementation' label='任务描述' sortable='true' :formatter='formatImplementation'></el-table-column>
                    <el-table-column prop='name' label='实例名称' sortable='true'></el-table-column>
                    <el-table-column prop='status' label='状态' width="80" sortable='true'
                                     :formatter='formatScheduleTaskStatus'></el-table-column>
                    <el-table-column prop='lastTime' label='最后一次执行时间' sortable='true'
                        :formatter="(row, column, cellValue, index) => this.timestampSecondFormatter(cellValue)"></el-table-column>
                    <el-table-column prop='cron' label='定时参数' width="110" sortable='true'></el-table-column>
                    <el-table-column prop='message' label='启动信息' sortable='true'></el-table-column>
                    <el-table-column prop='operator' width="110" label='操作人' sortable='true'></el-table-column>
                    <el-table-column prop='updateTime' label='修改时间' sortable='true'
                        :formatter="(row, column, cellValue, index) => this.timestampSecondFormatter(cellValue)"></el-table-column>
                    <el-table-column prop='operate' label='操作' width='120' align='center' fixed='right'>
                        <template slot-scope='scoped'>
                            <el-button size='small' type='text'
                                       @click='scheduleInstanceClickFun(`1`, scoped.row)'>编辑
                            </el-button>
                            <el-button size='small' type='text' @click='updateScheduleInstanceStatus(true, scoped.row)'>
                                启用
                            </el-button>
                            <el-button size='small' type='text'
                                       @click='updateScheduleInstanceStatus(false, scoped.row)'>停用
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class='pagination'>
                    <el-link :underline="false" style="float: right;font-size: 20px;font-size:20px;margin: 7px 0px 0px 20px;" icon="el-icon-refresh" @click="refresh()"></el-link>
                    <el-pagination
                        @size-change='handleSizeChange'
                        @current-change='handleCurrentChange'
                        :current-page='pwm.page'
                        :page-size='pwm.limit'
                        :page-sizes='pwm.limits'
                        layout='total, sizes, prev, pager, next, jumper'
                        :total='pwm.count'>
                    </el-pagination>
                </div>
            </div>
        </div>

        <el-dialog :title='scheduleTaskInstanceTitle' :visible.sync='scheduleTaskInstanceDialogVisible' class='dialog'
                   width='30%' :close-on-click-modal='false'>
            <div class='custom-dialog'>
                <el-form :model='scheduleTaskInstanceForm' ref='scheduleTaskInstanceForm'
                         :rules='scheduleTaskInstanceFormRule'>
                    <el-input v-if='false' v-model='scheduleTaskInstanceForm.id'></el-input>
                    <div style='padding-bottom: 15px'>
                        <div style='display: flex; padding-top: 15px'>
                            <div class='ar-form-item' style='width: 100%'>
                                <div style='display: flex'>
                                    <div class='ar-form-label'>
                                        <label><span style='color: red;'>*</span>任务描述</label>
                                    </div>
                                    <el-form-item class='ar-form-input' prop='implementation'>
                                        <el-select v-model='scheduleTaskInstanceForm.implementation' placeholder='请选择'
                                                   style='width: 100%'>
                                            <el-option v-for='item in implementationConditions' :key='item.value'
                                                       :label='item.label' :value='item.value'>
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div style='display: flex; padding-top: 15px'>
                            <div class='ar-form-item' style='width: 100%'>
                                <div style='display: flex'>
                                    <div class='ar-form-label'>
                                        <label><span style='color: red;'>*</span>实例名称</label>
                                    </div>
                                    <el-form-item class='ar-form-input' prop='name'>
                                        <el-input v-model='scheduleTaskInstanceForm.name'></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div style='display: flex; padding-top: 15px'>
                            <div class='ar-form-item' style='width: 100%'>
                                <div style='display: flex'>
                                    <div class='ar-form-label'>
                                        <label><span style='color: red;'>*</span>定时参数</label>
                                    </div>
                                    <el-form-item class='ar-form-input' prop='cron'>
                                        <el-input v-model='scheduleTaskInstanceForm.cron'></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
            <span slot='footer' class='dialog-footer'>
                <el-button type='primary' @click='saveScheduleTaskInstance(`scheduleTaskInstanceForm`, `3`)'
                           style='width: 80px'>保存并启用</el-button>
                <el-button type='primary' @click='saveScheduleTaskInstance(`scheduleTaskInstanceForm`, `0`)'
                           style='width: 80px'>保存</el-button>
                <el-button @click='scheduleTaskInstanceDialogVisible=false' style='width: 80px'>返回</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { fetchPost } from '../../../../https';

export default {
    data() {
        let validateCorn = (rule, value, callback) => {
            let parser = require('cron-parser');
            if (value === '') {
                callback('cron表达式不能为空');
            } else {
                try {
                    parser.parseExpression(value);
                    callback();
                } catch (e) {
                    callback('cron表达式不正确');
                }
            }
        };
        return {
            showColumn: false,
            pwm: {
                count: 0,
                limit: 0,
                page: 1,
                limits: [10, 20, 50, 100]
            },
            scheduleTaskInstanceTitle: '',
            scheduleTaskInstanceOpUrl: '',
            scheduleTaskInstanceDialogVisible: false,
            scheduleTaskInstanceTableData: [],
            scheduleTaskInstanceForm: {
                id: '',
                implementation: '',
                cron: '',
                name: '',
                status: '',
                lastTime: '',
                message: '',
                operator: '',
                updateTime: ''
            },
            scheduleTaskInstanceFormRule: {
                implementation: [
                    { required: true, message: '请选择任务描述', trigger: 'blur' }
                ],
                name: [
                    { required: true, message: '请输入任务名称', trigger: 'blur' }
                ],
                cron: [
                    { required: true, validator: validateCorn, trigger: 'blur' }
                ]

            },
            currGroupData: '',
            implementationConditions: []
        };
    },
    created: function() {
        this.getCurrentGroupData().then(() => {
            this.getImplementationConditions();
            this.getScheduleTaskInstanceByCurrGroupCode();
        });
    },
    methods: {
        refresh() {
            this.getScheduleTaskInstanceByCurrGroupCode();
        },
        handleSizeChange(val) {
            this.pwm.limit = val;
            this.getScheduleTaskInstanceByCurrGroupCode();
        },
        handleCurrentChange(val) {
            this.pwm.page = val;
            this.getScheduleTaskInstanceByCurrGroupCode();
        },
        scheduleInstanceClickFun(opType, row) {
            Object.keys(this.scheduleTaskInstanceForm).map(key => (this.scheduleTaskInstanceForm[key] = ''));
            this.$nextTick(() => {
                if (this.$refs.scheduleTaskInstanceForm) {
                    this.$refs.scheduleTaskInstanceForm.clearValidate();
                }
            });
            if (opType === '0') {
                this.scheduleTaskInstanceTitle = '新增定时任务实例';
                this.scheduleTaskInstanceOpUrl = 'sys/admin/addScheduleTaskInstance';
                this.scheduleTaskInstanceDialogVisible = true;
            } else if (opType === '1') {
                this.scheduleTaskInstanceTitle = '编辑定时任务实例';
                this.scheduleTaskInstanceOpUrl = 'sys/admin/updateScheduleTaskInstance';
                this.scheduleTaskInstanceDialogVisible = true;
                this.getScheduleTaskInstanceById(row);
            }
        },
        clickRowByChecked(row) {
            this.$refs.scheduleTaskInstanceTable.toggleRowSelection(row);
        },
        async getCurrentGroupData() { //  当前集团信息 : 同步执行
            await fetchPost('/sys/admin/getCurrentCompanyGroup', '').then(res => {
                if (res.data.success) {
                    this.currGroupData = res.data.obj;
                } else {
                    this.$message.error('获取当前集团信息错误：' + res.data.message);
                }
            }, error => {
                this.$message.error('获取当前集团信息错误：' + error);
            });
        },
        getScheduleTaskInstanceByCurrGroupCode() {
            this.pwm.search = { 'code': this.currGroupData.code };
            fetchPost('/sys/main/getScheduleTaskInstanceByCurrGroupCode', this.pwm).then(res => {
                this.scheduleTaskInstanceTableData = res.data.data;
                this.pwm.count = res.data.count;
            }, error => {
                this.$message.error('获取定时任务实例失败:' + error);
            });
        },
        getImplementationConditions() {
            fetchPost('/sys/main/getImplementationConditions', '').then(res => {
                this.implementationConditions = res.data.data;
                console.log(this.implementationConditions);
            });
        },
        saveScheduleTaskInstance(formName, status) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return false;
                }
                let data = this.scheduleTaskInstanceForm;
                data.code = this.currGroupData.code;
                if (status === '3') {
                    if (this.scheduleTaskInstanceForm.status !== '1') {
                        data.status = '3';
                    } else {
                        data.status = this.scheduleTaskInstanceForm.status;
                    }
                } else {
                    data.status = status;
                }
                fetchPost(this.scheduleTaskInstanceOpUrl, data).then(res => {
                    if (res.data.success) {
                        this.$message.success('保存定时任务实例成功');
                        this.scheduleTaskInstanceDialogVisible = false;
                        this.getScheduleTaskInstanceByCurrGroupCode();
                    } else {
                        this.$message.error('保存定时任务实例失败:' + res.data.message);
                    }
                }, error => {
                    this.$message.error('保存定时任务实例失败：' + error);
                });
            });
        },
        getScheduleTaskInstanceById(row) {
            fetchPost('/sys/admin/getScheduleTaskInstanceById', row.id).then(res => {
                if (res.data.success) {
                    this.scheduleTaskInstanceForm = res.data.obj;
                } else {
                    this.$message.error('加载定时任务实例信息失败:' + res.data.message);
                }
            }, error => {
                this.$message.error('加载定时任务实例失败：' + error);
            });
        },
        updateScheduleInstanceStatus(flag, row) {
            let param = {
                id: row.id,
                enable: flag
            };
            fetchPost('sys/admin/updateScheduleTaskInstanceStatus', param).then(res => {
                if (res.data.success) {
                    this.$message.success('更新状态成功');
                    this.getScheduleTaskInstanceByCurrGroupCode();
                } else {
                    this.$message.error('更新状态失败:' + res.data.message);
                }
            }, error => {
                this.$message.error('更新状态失败:' + error);
            });
        },
        formatScheduleTaskStatus(row, column) {
            let status = row.status;
            if ('0' === status) {
                return '停用';
            } else if ('1' === status) {
                return '已启动';
            } else if ('2' === status) {
                return '正在停用';
            } else if ('3' === status) {
                return '正在启动';
            } else if ('4' === status) {
                return '启动失败';
            }
        },
        formatImplementation(row, column) {
            let value = row.implementation;
            for (let i = 0; i < this.implementationConditions.length; i++) {
                if (this.implementationConditions[i].value === value) {
                    return this.implementationConditions[i].label;
                }
            }
        }


    }
};
</script>

<style scoped>

</style>
